// Include cached documents because the offline workspace shares one set of schemas.
export function schemaReferences(documents, motifs, kind, id) {
  if (!id || !['node', 'link'].includes(kind)) return []
  const references = documents.flatMap((document) =>
    (kind === 'node' ? [...document.paragraphs, ...document.units] : document.edges)
      .filter((item) => item.type === id)
      .map((item) => ({ item, key: 'type' })),
  )
  if (kind === 'link')
    references.push(
      ...motifs.filter((item) => item.linkType === id).map((item) => ({ item, key: 'linkType' })),
    )
  for (const motif of motifs) {
    const group = kind === 'node' ? motif.nodeTypes : motif.edgeTypes
    for (const key of Object.keys(group || {})) if (group[key] === id) references.push({ item: group, key })
  }
  return references
}

export function removeSchema(list, references, id, replacement) {
  const index = list.findIndex((item) => item.id === id)
  if (index < 0) throw new Error('分类不存在。')
  if (list.length <= 1) throw new Error('至少保留一个分类。')
  if (references.length && !list.some((item) => item.id !== id && item.id === replacement))
    throw new Error('请选择有效的替代分类。')
  for (const { item, key } of references) {
    item[key] = replacement
    if (key === 'type') {
      item.provenance = 'manual'
      if (item.typeStatus) item.typeStatus = 'ready'
    }
  }
  list.splice(index, 1)
}
